import { useState } from 'react';
import { DiceRoll, MoveOption } from '../components/Ludo/gameTypes';

export const useNaijaLudoState = () => {
  // Naija Ludo specific state for dice component
  const [diceRoll, setDiceRoll] = useState<DiceRoll | null>(null);
  const [moveOptions, setMoveOptions] = useState<MoveOption[]>([]);
  const [selectedMoveOption, setSelectedMoveOption] =
    useState<MoveOption | null>(null);
  const [selectedDiceValue, setSelectedDiceValue] = useState<number | null>(
    null
  );
  const [diceValueMoves, setDiceValueMoves] = useState<{
    [diceValue: number]: number[];
  }>({});

  // Handle move option selection
  const handleMoveOptionSelect = (option: MoveOption) => {
    setSelectedMoveOption(option);
  };

  // Handle dice value selection
  const handleDiceValueSelect = (value: number) => {
    setSelectedDiceValue(value);
  };

  // Execute selected move
  const handleExecuteMove = () => {
    if (selectedMoveOption && selectedDiceValue) {
      // This would trigger the actual move in the parent component
      return {
        moveOption: selectedMoveOption,
        diceValue: selectedDiceValue,
      };
    }
    return null;
  };

  // Reset selections
  const resetSelections = () => {
    setSelectedMoveOption(null);
    setSelectedDiceValue(null);
    setMoveOptions([]);
    setDiceValueMoves({});
  };

  return {
    // State
    diceRoll,
    moveOptions,
    selectedMoveOption,
    selectedDiceValue,
    diceValueMoves,

    // Setters
    setDiceRoll,
    setMoveOptions,
    setSelectedMoveOption,
    setSelectedDiceValue,
    setDiceValueMoves,

    // Actions
    handleMoveOptionSelect,
    handleDiceValueSelect,
    handleExecuteMove,
    resetSelections,
  };
};
